/* AW26 universe notify form — SMS-first signup to Klaviyo via the Client API.
   Uses the public company_id (safe to expose). Email is optional.
   Endpoint: POST https://a.klaviyo.com/client/subscriptions/?company_id=XXXX  (202 = success) */
(function () {
  function normPhone(raw, dial) {
    var v = (raw || "").replace(/[\s\-().]/g, "");
    if (!v) return "";
    if (v.indexOf("00") === 0) v = "+" + v.slice(2);
    if (v.charAt(0) === "+") return v;
    // local number, no country code -> prepend default dial code
    return (dial || "+45") + v;
  }
  function validPhone(e164) { return /^\+[1-9]\d{6,14}$/.test(e164); }
  function validEmail(x) { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(x); }

  function wire(form) {
    if (form.dataset.aw26Wired) return; // guard against double-include (notify section + pill section)
    form.dataset.aw26Wired = "1";
    var company  = form.getAttribute("data-company");
    var listId   = form.getAttribute("data-list");
    var revision = form.getAttribute("data-revision") || "2024-10-15";
    var dial     = form.getAttribute("data-dialcode") || "+45";
    var source   = form.getAttribute("data-source") || "AW26";
    var successMsg = form.getAttribute("data-success") || "You're on the list.";
    var tel    = form.querySelector('input[name="phone"]');
    var email  = form.querySelector('input[name="email"]');
    var emailWrap = form.querySelector("[data-aw26-email]");
    var emailToggle = form.querySelector("[data-aw26-email-toggle]");
    var btn    = form.querySelector('button[type="submit"]');
    var msg    = form.querySelector("[data-aw26-msg]");
    var busy = false;

    function show(text, kind) {
      if (!msg) return;
      msg.textContent = text;
      msg.classList.remove("is-ok", "is-err");
      if (kind) msg.classList.add(kind);
    }

    if (emailToggle && emailWrap) {
      emailToggle.addEventListener("click", function () {
        emailWrap.hidden = !emailWrap.hidden;
        emailToggle.style.display = emailWrap.hidden ? "" : "none";
        if (!emailWrap.hidden && email) email.focus();
      });
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (busy) return;
      show("");
      var phone = normPhone(tel && tel.value, dial);
      var em = (email && !emailWrap.hidden) ? email.value.trim() : "";
      if (!validPhone(phone)) { show("Please enter a valid mobile number (incl. country code).", "is-err"); if (tel) tel.focus(); return; }
      if (em && !validEmail(em)) { show("That email doesn't look right.", "is-err"); email.focus(); return; }

      // Klaviyo Client API: the subscribe action itself records consent per the
      // list's channel + opt-in settings. Profile takes plain email/phone_number.
      var profileAttrs = { phone_number: phone };
      if (em) { profileAttrs.email = em; }
      var payload = {
        data: {
          type: "subscription",
          attributes: { custom_source: source, profile: { data: { type: "profile", attributes: profileAttrs } } },
          relationships: { list: { data: { type: "list", id: listId } } }
        }
      };

      busy = true; btn.disabled = true; var label = btn.textContent; btn.textContent = "…";
      fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(company), {
        method: "POST",
        headers: { "Content-Type": "application/json", "revision": revision },
        body: JSON.stringify(payload)
      }).then(function (res) {
        if (res.status === 202 || res.ok) {
          show(successMsg, "is-ok");
          form.querySelectorAll("input").forEach(function (i) { i.value = ""; });
          btn.textContent = "Done ✓";
          if (window._learnq) { try { window._learnq.push(["track", "AW26 Notify Signup", { source: source }]); } catch (e) {} }
          try { form.dispatchEvent(new CustomEvent("aw26:notify:success", { bubbles: true, detail: { source: source } })); } catch (e) {}
        } else {
          return res.text().then(function (t) {
            var detail = "";
            try { var j = JSON.parse(t); detail = (j.errors && j.errors[0] && j.errors[0].detail) || ""; } catch (e) {}
            show(detail || "Something went wrong — please try again.", "is-err");
            btn.disabled = false; btn.textContent = label; busy = false;
          });
        }
      }).catch(function () {
        show("Network error — please try again.", "is-err");
        btn.disabled = false; btn.textContent = label; busy = false;
      });
    });
  }

  function boot() { document.querySelectorAll("[data-aw26-notify]").forEach(wire); }
  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", boot); } else { boot(); }
})();
